import { http } from '../../../api/http';
import type {
  AbrirCajaRequest,
  CerrarCajaRequest,
  SesionCajaResponse,
  CrearOrdenRequest,
  AgregarItemRequest,
  EmitirOrdenRequest,
  OrdenPosResponse,
  TalonarioOption,
} from '../types/pos.types';

export class PosService {
  private static readonly ENDPOINTS = {
    SESION_ABRIR: '/pos/sesion/abrir',
    SESION_CERRAR: '/pos/sesion/cerrar',
    SESION_ACTIVA: '/pos/sesion/activa',
    ORDEN: '/pos/orden',
    ORDENES: '/pos/ordenes',
  };

  public static async abrirSesion(data: AbrirCajaRequest): Promise<SesionCajaResponse> {
    try {
      const response = await http.post(this.ENDPOINTS.SESION_ABRIR, data);
      return response.data;
    } catch (error) {
      console.error('Error al abrir sesion:', error);
      throw error;
    }
  }

  public static async cerrarSesion(data: CerrarCajaRequest): Promise<SesionCajaResponse> {
    try {
      const response = await http.post(this.ENDPOINTS.SESION_CERRAR, data);
      return response.data;
    } catch (error) {
      console.error('Error al cerrar sesion:', error);
      throw error;
    }
  }

  public static async getSesionActiva(): Promise<SesionCajaResponse | null> {
    try {
      const response = await http.get(this.ENDPOINTS.SESION_ACTIVA);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status === 404) return null;
      console.error('Error al obtener sesion activa:', error);
      throw error;
    }
  }

  public static async crearOrden(data: CrearOrdenRequest): Promise<OrdenPosResponse> {
    try {
      const response = await http.post(this.ENDPOINTS.ORDEN, data);
      return response.data;
    } catch (error) {
      console.error('Error al crear orden:', error);
      throw error;
    }
  }

  public static async getOrden(id: number): Promise<OrdenPosResponse> {
    try {
      const response = await http.get(`${this.ENDPOINTS.ORDEN}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener orden:', error);
      throw error;
    }
  }

  public static async getOrdenes(): Promise<OrdenPosResponse[]> {
    try {
      const response = await http.get(this.ENDPOINTS.ORDENES);
      return response.data;
    } catch (error) {
      console.error('Error al obtener ordenes:', error);
      throw error;
    }
  }

  public static async agregarItem(idOrden: number, data: AgregarItemRequest): Promise<OrdenPosResponse> {
    try {
      const response = await http.post(`${this.ENDPOINTS.ORDEN}/${idOrden}/items`, data);
      return response.data;
    } catch (error) {
      console.error('Error al agregar item:', error);
      throw error;
    }
  }

  public static async actualizarItem(idOrden: number, idDetalle: number, data: AgregarItemRequest): Promise<OrdenPosResponse> {
    try {
      const response = await http.put(`${this.ENDPOINTS.ORDEN}/${idOrden}/items/${idDetalle}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar item:', error);
      throw error;
    }
  }

  public static async eliminarItem(idOrden: number, idDetalle: number): Promise<OrdenPosResponse> {
    try {
      const response = await http.delete(`${this.ENDPOINTS.ORDEN}/${idOrden}/items/${idDetalle}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar item:', error);
      throw error;
    }
  }

  public static async getTalonarios(idComprobante: number): Promise<TalonarioOption[]> {
    try {
      const response = await http.get(`/pos/talonarios/${idComprobante}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener talonarios:', error);
      throw error;
    }
  }

  public static async emitirOrden(id: number, data: EmitirOrdenRequest): Promise<any> {
    try {
      const response = await http.post(`${this.ENDPOINTS.ORDEN}/${id}/emitir`, data);
      return response.data;
    } catch (error) {
      console.error('Error al emitir orden:', error);
      throw error;
    }
  }

  public static async cancelarOrden(id: number): Promise<OrdenPosResponse> {
    try {
      const response = await http.post(`${this.ENDPOINTS.ORDEN}/${id}/cancelar`);
      return response.data;
    } catch (error) {
      console.error('Error al cancelar orden:', error);
      throw error;
    }
  }
}
